import { render, staticRenderFns } from "./profileDetails.vue?vue&type=template&id=446d4ca4"
import script from "./profileDetails.vue?vue&type=script&lang=js"
export * from "./profileDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports